/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_CopiedInputs */

const th_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัดลอกแล้ว`)
};

const en_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied`)
};

const ja_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーしました`)
};

const zh_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接已复制`)
};

const es_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace copiado`)
};

const pt_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copiado`)
};

const id_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan disalin`)
};

const fr_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien copié`)
};

const tl_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakopya ang link`)
};

const vi_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã chép liên kết`)
};

const ko_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`링크를 복사했습니다`)
};

const de_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopiert`)
};

const ru_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ссылка скопирована`)
};

const tr_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağlantı kopyalandı`)
};

const it_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copiato`)
};

const pl_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link skopiowany`)
};

const uk_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посилання скопійовано`)
};

const hi_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लिंक कॉपी हो गया`)
};

const ar_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نُسخ الرابط`)
};

const ms_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pautan disalin`)
};

const bn_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লিঙ্ক কপি হয়েছে`)
};

const zh_tw2_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已複製連結`)
};

const zh_hk2_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已複製連結`)
};

const ur_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لنک نقل ہو گیا`)
};

const fa_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پیوند رونوشت شد`)
};

const sw_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiungo kimenakiliwa`)
};

const nl_meeting_test_copied = /** @type {(inputs: Meeting_Test_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link gekopieerd`)
};

/**
* | output |
* | --- |
* | "Link copied" |
*
* @param {Meeting_Test_CopiedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_copied = /** @type {((inputs?: Meeting_Test_CopiedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_CopiedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_copied(inputs)
	if (locale === "ja") return ja_meeting_test_copied(inputs)
	if (locale === "zh") return zh_meeting_test_copied(inputs)
	if (locale === "es") return es_meeting_test_copied(inputs)
	if (locale === "pt") return pt_meeting_test_copied(inputs)
	if (locale === "id") return id_meeting_test_copied(inputs)
	if (locale === "fr") return fr_meeting_test_copied(inputs)
	if (locale === "tl") return tl_meeting_test_copied(inputs)
	if (locale === "vi") return vi_meeting_test_copied(inputs)
	if (locale === "ko") return ko_meeting_test_copied(inputs)
	if (locale === "de") return de_meeting_test_copied(inputs)
	if (locale === "ru") return ru_meeting_test_copied(inputs)
	if (locale === "tr") return tr_meeting_test_copied(inputs)
	if (locale === "it") return it_meeting_test_copied(inputs)
	if (locale === "pl") return pl_meeting_test_copied(inputs)
	if (locale === "uk") return uk_meeting_test_copied(inputs)
	if (locale === "hi") return hi_meeting_test_copied(inputs)
	if (locale === "ar") return ar_meeting_test_copied(inputs)
	if (locale === "ms") return ms_meeting_test_copied(inputs)
	if (locale === "bn") return bn_meeting_test_copied(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_copied(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_copied(inputs)
	if (locale === "ur") return ur_meeting_test_copied(inputs)
	if (locale === "fa") return fa_meeting_test_copied(inputs)
	if (locale === "sw") return sw_meeting_test_copied(inputs)
	if (locale === "nl") return nl_meeting_test_copied(inputs)
	return en_meeting_test_copied(inputs)
});